

































































































import { createComponent, ref, computed, Ref } from '@vue/composition-api';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage.vue';
import useModalService from '@sbvr/web-panel/modal';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';
import UIInput from '@sbvr/common/legacy-shared/components/ui/UIInput.vue';
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon.vue';
import Panel from '@sbvr/common/legacy-shared/components/Panel.vue';
import contentOwnershipsMock from './mocks/contentOwnerships.js';
import LibraryItemTr from './LibraryItemTr.vue';
import Draggable from 'vuedraggable';

import { useStore } from '@/core/store';
import { useRouter } from '@/core/routes';
import libraryStore from './store';

export default createComponent({
  name: 'LibraryIndexRoute',
  components: {
    LibraryItemTr,
    WebPanelPage,
    Draggable,
    Panel,
    UIButton,
    UIInput,
    UIIcon,
  },
  setup (props, { root }) {
    const store = useStore();
    if (!store.state.library) store.registerModule('library', libraryStore);
    store.dispatch('insertEntities', {
      name: 'ContentOwnership',
      payload: contentOwnershipsMock,
    }); // MOCK
    const games = computed(() =>
      store.getters['entities/ContentOwnership/all']()
    ); // MOCK
    function useFetchContent () {
      const isLoadingContent = ref(false);
      return {};
    }
    function useSearch () {
      const search = ref('');
      const gamesCount = computed(() => {
        return games.value.length;
      });
      // const gamesCount = computed(() => {
      //   return store.state.library.paginatorInfo && store.state.library.paginatorInfo.perPage;
      // });
      return { search, gamesCount, isLoadingContent };
    }
    const isLoadingContent = ref(false);
    const isLoading = ref(false);

    function useSort (opts: any) {
      const disabled: Ref<boolean> = opts.disabled;
      const draggableOpts = {
        handle: '.draghandle',
        animation: 150,
        scroll: true,
        disabled: disabled.value,
      };
      function sortGames () {}
      return { draggableOpts, sortGames };
    }
    const { ...search } = useSearch();
    const { ...sort } = useSort({ disabled: false });
    const { confirm } = useModalService(root);
    const router = useRouter();
    async function confirmAddContent () {
      const { confirmed } = await confirm({
        icon: 'upload-2',
        title: 'Adding Content',
        message:
          'This allows you to remotely distribute VR content across all devices.',
      });
      if (confirmed) router.push({ name: 'content-add' });
    }

    return {
      games,
      ...sort,
      ...search,
      isLoadingContent,
      isLoading,
      confirmAddContent,
    };
  },
});
// import Vue from 'vue';
// import Component from 'vue-class-component';
// import UIInput from '@/core/shared/components/ui/UIInput';
// import UIIcon from '@/core/shared/components/ui/UIIcon';
// import LibraryItemTrPlaceholder from './components/LibraryItemTrPlaceholder';
// import Panel from '@/core/shared/components/Panel';
// import Draggable from 'vuedraggable';
// import AgreementModalConnected from '@/content/shared/AgreementModalConnected';
// import FunctionalState from '@/core/shared/components/utils/FunctionalState';
// import { catchQueryErrors } from '@/core/shared/helpers/ErrorHelper';

// @Component({
//   name: 'LibraryRoute',
//   components: {
//     FunctionalState,
//     Draggable,
//     UIButton,
//     UIInput,
//     UIIcon,
//     Panel,
//     AgreementModalConnected,
//     LibraryItemTr: () => import('./components/LibraryItemTr'),
//     LibraryItemTrPlaceholder,
//   },
//   watch: {
//     search () {
//       this.$store.dispatch('searchLicenses');
//     },
//     isLoading (val) {
//       if (!val) this.cacheGames = this.games;
//     },
//     '$route.query': {
//       async handler (val) {
//         if (val.requireEula) {
//           const id = val.requireEula;
//           try {
//             await this.$store.dispatch('getGameAgreement', { id });
//           } catch (e) {
//             catchQueryErrors(e, () => {
//               this.resetQueryString();
//             });
//           }
//           const game = this.$store.getters['entities/Game'](id);
//           if (game) this.requireAgreementsForGame(game);
//         }
//       },
//       immediate: true,
//     },
//   },
// })
// export default class LibraryRoute extends Vue {
//   cacheGames = []
//   get games () {
//     if (this.loading) return this.cacheGames;
//     return this.search
//       ? this.$store.getters['entities/Game'](this.$store.state.library.searchResults)
//       : this.$store.getters['entities/Game'](this.$store.state.library.games);
//   }
//   get gameIds () {
//     return this.$store.state.library.games;
//   }
//   set gameIds (value) {
//     return this.$store.commit('library/set', { path: 'games', value });
//   }
//   get draggableOpts () {
//     return { handle: '.draghandle', animation: 150, scroll: true, disabled: !!this.search || !this.games.length };
//   }
//   get isLoading () {
//     return this.$store.state.library.isFetchingLicenses;
//   }
//   get gamesCount () {
//     return this.$store.state.library.paginatorInfo && this.$store.state.library.paginatorInfo.perPage;
//   }
//   get search () {
//     return this.$store.state.library.search;
//   }
//   set search (value) {
//     this.$store.commit('library/set', { path: 'search', value });
//   }
//   async created () {
//     await this.$store.dispatch('getMyLicenses');
//   }

//   sortGames () {
//     this.$store.dispatch('saveGamesOrder');
//   }
//   resetQueryString () {
//     const { requireEula, ...queryWithoutEula } = this.$route.query;
//     this.$router.push({ ...this.$route, query: queryWithoutEula });
//   }
//   get loadingGamesSet () {
//     return new Set(this.$store.state.library.gamesLoading);
//   }
//   get loadedGamesSet () {
//     return new Set(this.$store.state.library.gamesFullyLoaded);
//   }
//   onLibraryTrVisible ({ id }) {
//     if (!this.loadingGamesSet.has(id)) {
//       const gamesLoading = [...this.$store.state.library.gamesLoading, id];
//       this.$store.commit('library/set', { path: 'gamesLoading', value: gamesLoading });
//       this.$store.dispatch('lazyLoadGames');
//     }
//   }
//   async requireAgreementsForGame (game) {
//     await this.$nextTick();
//     await this.$refs.agreementmodalstate.setState({ game });
//     try {
//       await this.$refs.agreementmodal.requireAgreementsForGame();
//       this.$router.push({ name: 'content-library-show', params: { gameId: game.id } });
//     } catch (e) {
//       this.resetQueryString();
//     }
//   }
// }
